import { isPlainObject } from 'shared/utils/object';

/**
 * Messages that make a waiting worker take over. The value is the one
 * workbox-window sends from the update banner (`messageSkipWaiting`), so the
 * page and every worker version understand each other.
 */
export enum ServiceWorkerUpdateMessageType {
  skipWaiting = 'SKIP_WAITING',
}

export function isSkipWaitingMessage(data: unknown): boolean {
  return isPlainObject(data) && data.type === ServiceWorkerUpdateMessageType.skipWaiting;
}
